/**
 * Central config for the Clearbook integration.
 * The external booking page: kunden vælger tid direkte hos Clearbook.
 */
export const CLEARBOOK_BOOKING_URL = "https://clearbook.dk/booking/farumkloak/";

export const CLEARBOOK_CUSTOMER = "farumkloak";
export const CLEARBOOK_API_KEY = "75070fbe4e0956193f308707a73459f3";
export const CLEARBOOK_EMBED_SCRIPT = "https://api.clearbook.dk/embed.js";
